import React from "react";

interface MetricsCardsSkeletonProps {
  count?: number;
}

const MetricsCardsSkeleton: React.FC<MetricsCardsSkeletonProps> = ({ count = 4 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {[...Array(count)].map((_, index) => (
        <div
          key={index}
          className="flex flex-col p-4 rounded-lg border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 shadow-sm"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex-1 space-y-3">
              <div className="w-32 h-4 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
              <div className="w-24 h-7 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
            </div>
            <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-neutral-700 animate-pulse flex-shrink-0"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsCardsSkeleton;
